import React,{useEffect} from "react";
import "./Buy_Section.css";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Buy_eth() {

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);


  return (
    <div className="main_buy_eth" id="how_to_buy">
      <div className="container">
        <h2 className="main_heading_buy">
          How To Buy PIKU? <span className="outline_eth"></span>
        </h2>

        <div className="row mt-5" data-aos="fade-up"  data-aos-anchor-placement="top-bottom"  >
          <div className="col-md-4" >
            <div className="buy_main_box_here"  >
              <h4 className="piku-font">Buy PIKU With BNB</h4>
              <br></br>
              <ul className=" buy_ul">
                <li>
                  Paying with BNB is the quickest way to purchase PIKU tokens
                </li>
                <br></br>
                <li>
                  Using the BNB in your MetaMask or Trust Wallet, it’s an easy
                  token swap
                </li>
                <br></br>
                <li>
                  Keep a small amount of BNB in your wallet to cover the minimal
                  gas fee.
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4  mt-3 mt-md-0">
            <div className="buy_main_box_here">
              <h4 className="piku-font">Buy PIKU With USDT</h4>
              <br></br>
              <ul className=" buy_ul">
                <li>
                  You can also purchase PIKU tokens using USDT(Bep20) on the
                  BNB chain
                </li>
                <br></br>
                <li>Connect your wallet to the BSC network to pay with USDT</li>
                <br></br>
                <li>Have enough BNB left over to pay the gas fee.</li>
              </ul>
            </div>
          </div>
          <div className="col-md-4  mt-3 mt-md-0">
            <div className="buy_main_box_here">
              <h4 className="piku-font">Buy PIKU With USDC </h4>
              <br></br>
              <ul className=" buy_ul">
                <li>
                  You can also purchase PIKU tokens using USDC on BNB Chain.
                </li>
                <br></br>
                <li>
                  Connect your wallet to BSC chain and select USDC as a payment
                  option
                </li>
                <br></br>
                <li>Make sure you have BNB to pay the gas fee.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
